import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Dropdown } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { getAuditAsync, getAuditExpenseEntriesAsync,updatePagination,updateSorting } from "./AccountAuditSlice";
import { KTIcon, KTSVG, toAbsoluteUrl, useDebounce } from '../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../common/Pagination";
import { paginationStyles, sortData } from "../../common/timeLiveFunction";
import { getPageSizeArray } from "../../common/timeLiveFunction";
import { FormatInvoiceDecimalNumber, formatCurrntDateTime, formatHoursOff, formatDateWithDateAndMonthName, getFilteredList, getValueFromResource } from "../../common/timeLiveFunction";
import AccountAuditItem from "./AccountAuditItems";
import Loader from "../../common/Loader";
import { getEmployeeTimeOffAuditAsync } from "../admin/timeOffTypes/TimeOffTypeSlice";
import moment from "moment";
import clsx from "clsx";
import CanvasLoader from "../../common/CanvasLoader";
import PageSizeSelect from '../../common/PageSizeSelect';

interface SelectedObjectType {
    Id: any;
    TableName: string;
    Title: string;
}

const EmployeeTimeOffAudit = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { accountAuditList, expenseAuditList, isReload,sortOrder, sortColumn, search, pageNo, pageSize , isLoading, } = useAppSelector((state) => state.audit);
    const { decimalPlaces, cultureInfoName, pageId, menuList, maxMenuHeight, IsList, IsAdd, IsEdit, IsDelete, accountPreferenceList } = useAppSelector((state) => state.globalState);
    const { TimeOffTypeAuditList, employeeName, departmentName, locationName, policyName } = useAppSelector((state) => state.timeOffType);
    const [selectedObject, setSelectedObject] = useState<SelectedObjectType | null>(null);
    const [showModal, setShowModal] = useState(false);
    // const [pageSize, setPageSize] = useState(10);
    const [pageSizesheet, setPageSizesheet] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    const [currentPagesheet, setCurrentPagesheet] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [searchTermSheet, setSearchTermSheet] = useState('');
    const location = useLocation();
    const { obj } = location.state || {};
    document.title = obj.Title + ` | Livetecs`;
    const [isLoader, setIsLoader] = useState(true);
    const showConsumedHours = accountPreferenceList[0]?.IsShowConsumedHours ?? false;

    useEffect(() => {
        // dispatch(getAuditAsync({ TableName: obj.TableName, Id: obj.Id }));
        dispatch(getEmployeeTimeOffAuditAsync(obj));        
    }, [dispatch])


    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    // const handlePageChangeSheet = (pageNumber: any) => {
    //     setCurrentPagesheet(pageNumber);
    // };

    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1);

    // };

    // const handleSearchSheet = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTermSheet(value);
    //     setCurrentPagesheet(1);
    // };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSize(Number(value));
    //     setCurrentPage(1);
    // };

    // const handlePageSizeChangeSheet = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSizesheet(Number(value));
    //     setCurrentPagesheet(1);
    // };

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }

        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const formatAuditValue = (value: any, cultureInfoName: any, decimalPlaces: any) => {
        const valueType = detectValueType(value);
        switch (valueType) {
            case 'BOOLEAN':
                return value === '1' || value === 'true' || value === 'True' || value === true
                    ? getValueFromResource('Yes', dispatch, t)
                    : getValueFromResource('No', dispatch, t);

            case 'DATETIME':
                return formatCurrntDateTime(value, cultureInfoName.toString());

            case 'DATE':
                return formatDateWithDateAndMonthName(value, cultureInfoName.toString());

            case 'NUMERIC':
                return FormatInvoiceDecimalNumber(cultureInfoName.toString(), value, decimalPlaces);

            case 'TEXT':
            default:
                return getValueFromResource(value, dispatch, t);
        }
    };

const detectValueType = (value: any) => {
    if (!value || value === '') return 'TEXT';
    
    const strValue = String(value).trim();
    
    if (strValue === '0' || strValue === '1' || 
        strValue.toLowerCase() === 'true' || strValue.toLowerCase() === 'false') {
        return 'BOOLEAN';
    }
    
    const datetimePattern = /\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/;
    if (datetimePattern.test(strValue)) {
        return 'DATETIME';
    }
    
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if (datePattern.test(strValue)) {
        return 'DATE';
    }
    
    if (!isNaN(parseFloat(value)) && isFinite(value) && 
        !/[a-zA-Z]/.test(strValue) && 
        strValue !== '0' && strValue !== '1') {
        return 'NUMERIC';
    }
    
    return 'TEXT';
};
    
    const filteredData: any = getFilteredList(TimeOffTypeAuditList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = TimeOffTypeAuditList.length;
    const recordsFiltered = filteredData.length;
 
    // const TimeOffTypeData: any = getFilteredList(TimeOffTypeAuditList, searchTerm);
    // const indexOfLastItemTimeOffType = currentPage * pageSize;
    // const indexOfFirstItemTimeOffType = indexOfLastItemTimeOffType - pageSize;
    // const TimeOffTypeItems = TimeOffTypeData.slice(indexOfFirstItemTimeOffType,indexOfLastItemTimeOffType);
    // const totalTimeOffTypeItems = TimeOffTypeAuditList.length;
    // const recordsTimeOffTypeItemsFiltered = Object.values(TimeOffTypeData).length;



    const handleShowModal = (expenseentryId: any) => {
        setSelectedObject({ Id: expenseentryId, TableName: 'AccountExpenseEntry', Title: 'Expense Entry Audit' });
        dispatch(getAuditExpenseEntriesAsync({ TableName: 'AccountExpenseEntry', Id: expenseentryId }));
        setShowModal(true);
        setIsLoader(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
     
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    

    return (
        <>
            {isLoading ? <Loader />
            : <>
            <div className="row col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
            {/* <div className="row col-md-15 col-sm-15 col-xs-12 mt-3 mb-3 d-flex justify-content-center align-items-center"> */}
                <div className='col-md-3 col-sm-3 col-xs-12' >
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/Employee.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Employee`)} */}
                                    {getValueFromResource('Employee',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">
                                    {t(employeeName)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' >
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/TimeOffPolicy.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Time Off Policy Name`)} */}
                                    {getValueFromResource('Time Off Policy Name',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">
                                    {t(policyName)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' >
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/Location.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Location Name`)} */}
                                    {getValueFromResource('Location Name',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">
                                    {t(locationName)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' >
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/Department.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Department Name`)} */}
                                    {getValueFromResource('Department Name',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">
                                    {t(departmentName)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t(obj.Title)} */}
                        {getValueFromResource(obj.Title,dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                options={getPageSizeArray()}
                                value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                            <PageSizeSelect onChange={handlePageSizeChange} />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {/* {(TimeOffTypeItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalTimeOffTypeItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsTimeOffTypeItemsFiltered}
                                >
                                </CustomPagination>
                            ) : null} */}
                             {(currentItems.length > 0) ? (
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    >
                                    </CustomPagination>
                                ) : null}
                        </div>
                    </div>
                </div>
                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' >
                    <thead>
                        <tr className="thHeading align-middle " >
                        <th style={{ width: '6%', textAlign:'center'  }}>
                            {/* {t('Executed Date')} */}
                            {getValueFromResource('Executed Date',dispatch, t)}
                            {sortColumn === 'ExecutedDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExecutedDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExecutedDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExecutedDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExecutedDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '6%' }}>
                            {/* {t('Time Off Type')} */}
                            {getValueFromResource('Time Off Type',dispatch, t)}
                            {sortColumn === 'AccountTimeOffType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountTimeOffType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountTimeOffType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountTimeOffType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountTimeOffType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '4%', textAlign:'center'  }}>
                            {/* {t('Earned')} */}
                            {getValueFromResource('Earned',dispatch, t)}
                            {sortColumn === 'EarnedHours' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EarnedHours") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EarnedHours") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EarnedHours") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EarnedHours") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {showConsumedHours && <th style={{ width: '4%', textAlign:'center' }}>
                            {/* {t('Consumed')} */}
                            {getValueFromResource('Consumed',dispatch, t)}
                            {sortColumn === 'ConsumeHours' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ConsumeHours") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ConsumeHours") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ConsumeHours") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ConsumeHours") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>}
                        <th style={{ width: '5%', textAlign:'center' }}>
                            {/* {t('Available')} */}
                            {getValueFromResource('Available',dispatch, t)}
                            {sortColumn === 'AvailableHours' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AvailableHours") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AvailableHours") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AvailableHours") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AvailableHours") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '5%', textAlign:'center' }}>
                            {/* {t('Carry Forward')} */}
                            {getValueFromResource('Carry Forward',dispatch, t)}
                            {sortColumn === 'CarryForward' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "CarryForward") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "CarryForward") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "CarryForward") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "CarryForward") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '6%', textAlign:'center' }}>
                            {/* {t('Last Earned Date')} */}
                            {getValueFromResource('Last Earned Date',dispatch, t)}
                            {sortColumn === 'LastEarnedDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "LastEarnedDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5  "></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "LastEarnedDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "LastEarnedDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "LastEarnedDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '6%', textAlign:'center' }}>
                            {/* {t('Last Reset Date')} */}
                            {getValueFromResource('Last Reset Date',dispatch, t)}
                            {sortColumn === 'LastResetDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "LastResetDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "LastResetDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "LastResetDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "LastResetDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '7%' }}>
                            {/* {t('Audit Period Type')} */}
                            {getValueFromResource('Audit Period Type',dispatch, t)}
                            {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '6%' }}>
                            {/* {t('Audit Action')} */}
                            {getValueFromResource('Audit Action',dispatch, t)}
                            {sortColumn === 'AuditAction' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AuditAction") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AuditAction") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AuditAction") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AuditAction") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '6%' }}>
                            {/* {t('Execution Type')} */}
                            {getValueFromResource('Execution Type',dispatch, t)}
                            {sortColumn === 'ExecutionType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExecutionType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExecutionType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExecutionType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExecutionType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                         <th style={{ width: '6%' }}>
                            {getValueFromResource('Modified By',dispatch, t)}
                            {sortColumn === 'ModifiedByEmployeeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ModifiedByEmployeeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ModifiedByEmployeeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ModifiedByEmployeeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ModifiedByEmployeeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '6%' }}>
                            {/* {t('Audit Source')} */}
                            {getValueFromResource('Audit Source',dispatch, t)}
                            {sortColumn === 'AuditSource' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AuditSource") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AuditSource") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AuditSource") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AuditSource") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        </tr>
                    </thead>
                    <tbody>

                        {currentItems.length > 0 && currentItems.map((auditList: any, i: any) => (
                            <tr key={i} style={{ height: 42 }}>
                                <td className="text-center">{auditList.ExecutedDate ? formatDateWithDateAndMonthName(auditList.ExecutedDate, cultureInfoName.toString()) : ''}</td>
                                {/* <td>{auditList.ExecutedDate}</td> */}
                                <td>{auditList.AccountTimeOffType}</td>
                                <td className="text-center">{formatHoursOff(Number(auditList.EarnedHours), 2, cultureInfoName.toString())}</td>
                                {showConsumedHours && <td className="text-center">{formatHoursOff(Number(auditList.ConsumeHours), 2, cultureInfoName.toString())}</td>}
                                <td className="text-center">{formatHoursOff(Number(auditList.AvailableHours), 2, cultureInfoName.toString())}</td>
                                <td className="text-center">{formatHoursOff(Number(auditList.CarryForward), 2, cultureInfoName.toString())}</td>
                                <td className="text-center">{auditList.LastEarnedDate ? formatDateWithDateAndMonthName(auditList.LastEarnedDate, cultureInfoName.toString()) : ''}</td>
                                <td className="text-center">{auditList.LastResetDate ?  formatDateWithDateAndMonthName(auditList.LastResetDate, cultureInfoName.toString()) : ''}</td>
                                <td>{auditList.AuditPeriodType}</td>
                                <td>{auditList.AuditAction}</td>
                                <td>{auditList.ExecutionType}</td>
                                 <td>{auditList.ModifiedByEmployeeName}</td>
                                <td>{auditList.AuditSource}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {currentItems.length === 0 &&
                    <div className=''>
                        <p className='noDataFound'>
                            {/* {t('No Record Found')} */}
                            {getValueFromResource('No Record Found',dispatch, t)}
                            </p>
                    </div>
                }

            </div>
            </>
            }
            <div className="modal drawer-overlay" tabIndex={-1} data-bs-backdrop="false" id="expenseentryModal" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl' role="document">
                    <div className='modal-content rounded'>
                        <div className="modal-header">
                            <h6 className="modal-title">
                                {/* {t('Expense Entries Audit')} */}
                                {getValueFromResource('Expense Entries Audit',dispatch, t)}
                                </h6>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>

                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                        {isLoader ? <CanvasLoader/> : <>
                            <div className="table-responsive">
                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ marginLeft: '10px' }}>
                                    <thead>
                                        <tr className="thHeading align-middle " >
                                            <th className='w-20' >
                                                {/* {t('Updated Date')} */}
                                                {getValueFromResource('Updated Date',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('Field Name')} */}
                                                {getValueFromResource('Field Name',dispatch, t)}
                                                </th>
                                            <th className='w-20'> 
                                                {/* {t('Old Value')} */}
                                                {getValueFromResource('Old Value',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('New Value')} */}
                                                {getValueFromResource('New Value',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('Update By')} */}
                                                {getValueFromResource('Update By',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {expenseAuditList.length > 0 && expenseAuditList.map((auditList: any, i: any) => (
                                            <tr key={i} style={{ height: 42 }}>
                                                <td>
                                                    {/* {moment(auditList.UpdatedOn).format('M-D-YYYY - h:mm A')} */}
                                                    {formatCurrntDateTime(auditList.UpdatedOn, cultureInfoName.toString())}
                                                </td>
                                                <td>
                                                    {auditList.FieldName}
                                                </td>
                                                <td >
                                                    {auditList.OldValue}
{/*                                                     {formatAuditValue(
                                                        auditList.OldValue,
                                                        cultureInfoName,
                                                        decimalPlaces
                                                    )} */}
                                                </td>
                                                <td >
                                                    {auditList.NewValue}
{/*                                                     {formatAuditValue(
                                                        auditList.OldValue,
                                                        cultureInfoName,
                                                        decimalPlaces
                                                    )} */}
                                                </td>
                                                <td >
                                                    {auditList.UpdateBy}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {(!Array.isArray(expenseAuditList) || expenseAuditList.length === 0) && (
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                )}
                            </div>
                            </>
                         }
                        </div>
                        <div className="modal-footer"  >
                            <button
                                type="button"
                                className="btn btn-light btn-sm"
                                data-bs-dismiss="modal"
                            >
                              {/* {t('Cancel')}   */}
                              {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default EmployeeTimeOffAudit